var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoGallery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "ico-gallery",
    width: 19,
    height: 19,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAABl0lEQVQ4jaXUPY+MYRTG8d8+GRaNRRSyCpItFBIvhYhqbSGhIHwD32G3VYhkhY9BIYqlQLmxKiQ6xRYiJPRrg413OVxP8mQyk5nlaibPPdf555xzn/tMHFp8BtuxgEvYj57R+o53WMJNbPQCWsbJMQD92oMjOIu5XjIq0Aau4jl+jgFqcAJXEr/QS2kCur7JzJbzu1icJj2SjEbpIO7jXMfXxk31Os0ep7TTuIBPeNQfN+zWduAUPqOu+0fOb+dsZVDQINgs7mJvvl/iIl7hK+4MS7vp+55L+gVaxxccxmPMdHzVu+PYMgx2DA8yd9XUA5mh95gOsDwP8Rov8CaeP6oXsIadyWIyoDP4EM9MQNMpc2vOvyWzNu5t0+nbIJD0ajZnBfqFy9gX/2R825qUVVodAOoCz2ckJnANu+JfjWd3kzRL80NArZ7gaKeHN+Kfz//rTeZG3uYotSXfw62+uI9N1og82nFUwHrPBezGrVXzax/V9dbrL/3L1igt1Wj8zz5r9bTdZ1VzTX67aac2AakZ/btp2fgNnDhjKGhQFSkAAAAASUVORK5CYII="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGallery);
export default __webpack_public_path__ + "static/media/ico_gallery.e41b92cc.svg";
export { ForwardRef as ReactComponent };